<template>
  <div>
    <div class="card mb-4">
      <div class="card-body p-4 p-md-5">
        <p>
          Klient potvrdzuje, že ním uvádzané odpovede v tomto teste vhodnosti a
          primeranosti (ďalej aj ako „dotazník“) budú správne, úplné, pravdivé.
          Pri svojich odpovediach nič nezamlčí a nebude uvádzať klamlivé ani
          zavádzajúce informácie.
        </p>
        <p>
          Klient zároveň potvrdzuje, že bol poučený o tom, že nesprávne, neúplné
          alebo nepravdivé odpovede môžu mať za následok nesprávne vyhodnotenie
          jeho investičného profilu ako aj nesprávne poskytnutie klientom
          požadovanej služby.
        </p>
        <p class="mt-4 pt-3">
          <a href="" target="_blank" class="text-highlighted"
            ><font-awesome-icon icon="info-circle" class="mr-2" />
            Ďalšie základné informácie k investičnému dotazníku.
          </a>
        </p>
      </div>
    </div>
    <investment-questionnaire-form />
  </div>
</template>

<script>
import InvestmentQuestionnaireForm from "../components/InvestmentQuestionnaireForm";

export default {
  name: "InvestmentQuestionnaire",
  components: {
    InvestmentQuestionnaireForm
  }
};
</script>
